import { useSearchParams } from 'react-router-dom'
import { ratingParams } from '../components/MasterRatingFilter';
import { useFetch } from '../../../../../hooks/Fetching';
import { useInfiniteQuery } from '@tanstack/react-query';
import { fetch } from '../../../../../enums/queryFunction/Fetch';
import useUser from '../../../../../hooks/useUser';

export default function useGetFeedbacks(url) {
    const [searchParams] = useSearchParams();
    const key = buildFeedbackQueryKey(url, searchParams)
    const {profile} = useUser()
    return useInfiniteQuery({
    // Must be an array: callers (delete, mark as read) invalidate with [key],
    // and react-query never matches a bare-string key against an array filter.
    queryKey: [key],
    queryFn: async ({ pageParam = 0 }) => {
      const res = await fetch(
        `${key}&pageNumber=${pageParam}&size=12` 
      );
      return res; 
    },

    getNextPageParam: (lastPage) => { //Getting next page 
      const nextPage = lastPage?.number + 1;
      return nextPage < lastPage?.totalPages ? nextPage : undefined; //If page exists
    },

    enabled: !!profile?.id, //Don't enable api fetching until logged in user is fetched
  });    
}


export function buildFeedbackQueryKey(url, searchParams) {
    const readParam = searchParams.get(ratingParams.read) ?? "all";
    const ratingParam = searchParams.get(ratingParams.rating) ?? "all";
    return `${url}?read=${readParam}&rating=${ratingParam}`;
}
